import { useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import useGuestHashSystem from '../systems/useGuestHashSystem';
import { QueryKeys } from './queryKeys';
import { DEFAULT_QUERY_OPTIONS } from './constants';
import GuestHash, { GuestHashJSON } from '../models/guestHash';

type UseFetchGuestHashesForProjectQueryParams = {
	projectID: number,
	enabled?: boolean
}

const useFetchGuestHashesForProjectQuery = ( {
	projectID, enabled = true
}: UseFetchGuestHashesForProjectQueryParams ) => {
	const system = useGuestHashSystem();
	const select = useCallback(
		( data: GuestHashJSON[] ) => (
			GuestHash.allFromJson( data ).sort( ( a, b ) => a.role.level - b.role.level )
		),
		[]
	);

	return useQuery(
		QueryKeys.forGuestHashes( projectID ),
		() => system.fetchGuestHashes( projectID ),
		{
			...DEFAULT_QUERY_OPTIONS,
			select,
			enabled
		}
	);
};

export default useFetchGuestHashesForProjectQuery;
